import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAdmin, setIsAdmin] = useState(() => {
        return JSON.parse(sessionStorage.getItem("isAdmin")) || false;
    });

    useEffect(() => {
        sessionStorage.setItem("isAdmin", JSON.stringify(isAdmin));
    }, [isAdmin]);

    return (
        <AuthContext.Provider value={{ isAdmin, setIsAdmin }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
